<template>
  <OptionInput
    type="radio"
    :value="option.label"
    :modelValue="modelValue"
    :updateFn="updateValue"
    :option="option"
    class="option-input--radio"
  >
    <span class="option-input__label">
      {{ option.label }}
    </span>
  </OptionInput>
</template>

<script setup lang="ts">
import { QuestionnaireFormOption } from '@/models/onboarding.types'
import OptionInput from './OptionInput.vue'

defineProps<{
  modelValue: string[]
  option: QuestionnaireFormOption
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()

function updateValue(event: Event): void {
  const input = event.target as HTMLInputElement
  if (!input || !input.checked) {
    return
  }

  emit('update:modelValue', [input.value])
}
</script>
